export function getDefaultPhoneInternationalPrefix() {
  return import.meta.env.VITE_PHONE_NUMBER_COUNTRY_CODE;
}

export function getContactPhoneNumber() {
  return import.meta.env.VITE_CONTACT_PHONE;
}

export enum PHONE_NUMBER_FORMAT {
  SYSTEM = 'SYSTEM',
  DISPLAY = 'DISPLAY',
  CLEAN = 'CLEAN',
}

/**
 * The difference between this function and the one inside string.ts is that this one is for fixed phone numbers, or system phone numbers
 */
export function formatPhoneNumber(
  phoneNumber: string | undefined | null,
  format: PHONE_NUMBER_FORMAT = PHONE_NUMBER_FORMAT.DISPLAY,
  includeCountryCode = false
) {
  if (!phoneNumber) {
    return '';
  }

  let cleanedNumber = phoneNumber.replace(/\D/g, '');

  switch (format) {
    case PHONE_NUMBER_FORMAT.DISPLAY: {
      // Check if the cleaned number has 10 digits
      if (cleanedNumber.length !== 10) {
        return phoneNumber; // Return original if not a valid 10-digit number
      }

      // Format the number with dots
      return `${includeCountryCode ? `${import.meta.env.VITE_PHONE_NUMBER_COUNTRY_CODE} ` : ''}${cleanedNumber.slice(0, 3)}.${cleanedNumber.slice(3, 6)}.${cleanedNumber.slice(6)}`;
    }

    case PHONE_NUMBER_FORMAT.CLEAN: {
      let includedCountryCode: string | null = null;
      if (phoneNumber.startsWith('+')) {
        includedCountryCode = phoneNumber.split(' ')[0];
        cleanedNumber = phoneNumber.split(' ')[1];
      }

      // Check if the number is 10 digits
      if (!cleanedNumber || cleanedNumber.length !== 10) {
        return phoneNumber;
      }

      // Format the phone number
      return `${includeCountryCode ? (!includedCountryCode ? `${import.meta.env.VITE_PHONE_NUMBER_COUNTRY_CODE} ` : `${includedCountryCode} `) : ''}(${cleanedNumber.slice(0, 3)}) ${cleanedNumber.slice(3, 6)}-${cleanedNumber.slice(6)}`;
    }

    case PHONE_NUMBER_FORMAT.SYSTEM: {
      return `${getDefaultPhoneInternationalPrefix()}${phoneNumber.replace(/\D/g, '')}`;
    }
  }
}
